import {Trans} from "react-i18next";
import React from "react";

export default function AddonComponent({addon, Status, Information, PrimaryCta, CancelSubscriptionCta}) {
    return (
        <div className={`addonSubscriptionInformation-wrapper`}>
            <div className={"addonSubscriptionInformation-content"}>
                <div className={"addonSubscriptionInformation-header"}>
                        <span className={"addonSubscriptionInformation-header-title"}>
                            <Trans i18nKey="accountAddonProductTitle"
                                   values={{addon: addon}}
                                   tOptions={{interpolation: {escapeValue: false}}}/>
                        </span>
                    {/*<Status className={"addonSubscriptionInformation-header-status"}/>*/}
                </div>
                <Information />
            </div>
            <div className={"addonSubscriptionInformation-ctas"}>
                <PrimaryCta />
                <CancelSubscriptionCta />
            </div>
        </div>
    )
}